<section>
  @if (data.layout; as layout) {
    @switch (layout) {
      @case ("it2ivi") {
        <app-galerie-it2ivi
          (zoomImageRequested)="openVisualFullScreenModal($event)"
          [data]="data"
          [isImageInPreviousBlocks]="isImageInPreviousBlocks" />
      }
      @case ("4itiv") {
        <app-galerie-4itiv
          (zoomImageRequested)="openVisualFullScreenModal($event)"
          [data]="data"
          [isImageInPreviousBlocks]="isImageInPreviousBlocks" />
      }
      @case ("2iv2it") {
        <app-galerie-2iv2it
          (zoomImageRequested)="openVisualFullScreenModal($event)"
          [data]="data"
          [isImageInPreviousBlocks]="isImageInPreviousBlocks" />
      }
      @case ("2it4i") {
        <app-galerie-2it4i
          (zoomImageRequested)="openVisualFullScreenModal($event)"
          [data]="data"
          [isImageInPreviousBlocks]="isImageInPreviousBlocks" />
      }
    }
  }
</section>
